<template>
    <div class="pane_container">
      <div class="pane left_pane" v-if="showRegister">
        <img :src="require('../../assets/home_modal_1.png')" class="pane_img">
        <div class="header_text">Registration Successful!</div>
        <u-btn-b btnWidth="100%" style="margin: 10px 0" @click.native.prevent="GotoHome">Go to Home Page</u-btn-b>
      </div>
      <div class="pane left_pane" v-else>
        <img :src="require('../../assets/home_modal_1.png')" class="pane_img">
        <div class="header_text">Login Successful!</div>
        <u-btn-b btnWidth="100%" style="margin: 10px 0" @click.native.prevent="GotoHome">Go to Home Page</u-btn-b>
      </div>
      <div class="pane right_pane">
        <img :src="require('../../assets/home_modal_2.png')" class="pane_img">
        <div class="header_text text-white">Goto User Profile!</div>
        <u-btn-b btnWidth="100%" style="margin: 10px 0" @click.native.prevent="GotoProfile()">View User Profile</u-btn-b>
        <ul style="color: white">
          <li>Access recorded video lessons</li>
          <li>Generate certificates</li>
          <li>View resources</li>
          <li>Manage account information</li>
        </ul>
      </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      showRegister: false
    }
  },
  created() {
    if (this.PendingFirstTimer()) {
      this.showRegister = true
      this.RemoveFirstTimer()
    }
  }
}
</script>

<style scoped>
/*pane starts*/
.left_pane {
  background: #F6F6F6 0% 0% no-repeat padding-box;
}
.pane {
  display: flex;
  flex-direction: column;
  /*justify-content: center;*/
  padding: 20px 0;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
}
.right_pane {
  background: #013686 0% 0% no-repeat padding-box;
  opacity: 1;
}
.pane_container {
  display: flex;
}

@media screen and (max-width: 800px) {
  .pane_container {
    flex-direction: column;
  }
}
.pane_img {
  max-width: 300px;
  object-fit: contain;
}
.header_text {
  font: normal normal bold 24px/40px Montserrat;
  letter-spacing: -0.6px;
  color: #000000;
}
.pane:hover {
  opacity: 0.9;
  cursor: pointer;
}
.left_pane:hover {
  background-color: #00c936;
}
.right_pane:hover {
  background-color: #00c936;
}
/*pane ends*/
</style>